

import state from './moduleHistoriquesState.js'
import mutations from './moduleHistoriquesMutations.js'
import actions from './moduleHistoriquesActions.js'
import getters from './moduleHistoriquesGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}

